import { isEmpty, path } from 'ramda'
import { createSelector } from 'reselect'

const getRates = state => state.expediaRates

export const selectRatesFetching = state => path(['expediaRates', 'isFetching'], state)

export const selectRates = createSelector(getRates, rates => {
    if (!(isEmpty(rates.entities) || isEmpty(rates.result))) {
        const items = rates.entities.rates
        return rates.result.map(id => items[id])
    } else {
        return []
    }
})



// WEBPACK FOOTER //
// ./src/selectors/expediaSelectors/expediaRates.js